export default __webpack_public_path__ + "static/media/Logo_White.a42b0af3.png";